/* LINGCAGE / ASH — Lightweight interactions */

(function () {
  'use strict';

  // 1. Cart count demo (placeholder)
  document.querySelectorAll('[href="#preorder"] .btn-primary, .btn-block').forEach(btn => {
    btn.addEventListener('click', e => {
      const pill = document.querySelector('.cart-count');
      if (!pill) return;
      const next = parseInt(pill.textContent || '0', 10) + 1;
      pill.textContent = next;
      pill.style.transform = 'scale(1.3)';
      setTimeout(() => { pill.style.transform = 'scale(1)'; }, 200);
    });
  });

  // 2. Scroll reveal — reveal state is owned by CSS, JS only adds classes.
  //    No-JS / JS-error => nothing is ever hidden.
  const REVEAL_SEL = [
    '.story', '.craft', '.specs', '.preorder-card', '.unbox-card',
    '.nextdrop-inner', '.bundle-card', '.brand-card'
  ].join(', ');

  const show = el => {
    el.classList.add('is-visible');
    el.style.opacity = '';
    el.style.transform = '';
  };

  if ('IntersectionObserver' in window) {
    document.documentElement.classList.add('has-reveal');

    const io = new IntersectionObserver((entries, obs) => {
      entries.forEach(e => {
        if (e.isIntersecting) { show(e.target); obs.unobserve(e.target); }
      });
    }, { threshold: 0.05, rootMargin: '0px 0px -40px 0px' });

    document.querySelectorAll(REVEAL_SEL).forEach(el => {
      el.classList.add('reveal');
      io.observe(el);
    });

    // Horizontal strips: cards clipped by overflow-x never intersect on their own,
    // so observe the STRIP and reveal all its cards together (staggered).
    const stripIO = new IntersectionObserver((entries, obs) => {
      entries.forEach(e => {
        if (!e.isIntersecting) return;
        e.target.querySelectorAll('.collection-card').forEach((card, i) => {
          card.classList.add('reveal');
          card.style.transitionDelay = (i * 0.06) + 's';
          show(card);
        });
        obs.unobserve(e.target);
      });
    }, { threshold: 0.05, rootMargin: '0px 0px -40px 0px' });

    document.querySelectorAll('.collection-strip').forEach(s => stripIO.observe(s));

    // Safety net — under no circumstance may content stay invisible.
    const forceRevealAll = () => {
      document.querySelectorAll('.reveal:not(.is-visible), .collection-card').forEach(show);
    };
    window.addEventListener('load', () => setTimeout(forceRevealAll, 1000));
    setTimeout(forceRevealAll, 2500);
    window.addEventListener('error', () => setTimeout(forceRevealAll, 0));
  }

  // 3. Nav background intensifies on scroll
  const nav = document.querySelector('.nav');
  const onScroll = () => {
    if (window.scrollY > 40) {
      nav.style.background = 'rgba(10, 10, 15, 0.92)';
      nav.style.borderBottomColor = 'rgba(255,255,255,0.12)';
    } else {
      nav.style.background = 'rgba(10, 10, 15, 0.75)';
      nav.style.borderBottomColor = 'rgba(255,255,255,0.06)';
    }
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  // 4. Hero parallax (subtle, applied to all heroes — ASH + LIN YUANZHE)
  const heroProducts = document.querySelectorAll('.hero-product');
  if (heroProducts.length && window.matchMedia('(min-width: 1024px)').matches) {
    let ticking = false;
    window.addEventListener('scroll', () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          heroProducts.forEach(hp => {
            const y = Math.min(window.scrollY, 800);
            hp.style.transform = `translateY(${-y * 0.12}px) scale(${1 - y * 0.0001})`;
          });
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  // 5. LIN YUANZHE product video — hover to play with sound, leave to pause & mute
  document.querySelectorAll('.preorder-video video').forEach(v => {
    const wrap = v.closest('.preorder-video');
    if (!wrap) return;
    v.muted = true;
    v.play().catch(() => {}); // start muted loop
    wrap.addEventListener('mouseenter', () => {
      v.muted = false;
      v.play().catch(() => {});
    });
    wrap.addEventListener('mouseleave', () => {
      v.muted = true;
      v.play().catch(() => {});
    });
    v.addEventListener('play', () => wrap.classList.add('playing'));
    v.addEventListener('pause', () => wrap.classList.remove('playing'));
  });

  // 7. Warm the horizontal gallery images once the page has settled.
  //    Cards clipped by overflow-x never count as "near viewport" for
  //    loading="lazy", so they would stay blank until swiped. Flip them
  //    to eager after load — fast first paint, no empty cards on swipe.
  const warmGallery = () => {
    document.querySelectorAll('.collection-strip img').forEach(img => {
      if (img.loading === 'lazy') img.loading = 'eager';
    });
  };
  if ('requestIdleCallback' in window) {
    window.addEventListener('load', () => requestIdleCallback(warmGallery, { timeout: 2000 }));
  } else {
    window.addEventListener('load', () => setTimeout(warmGallery, 1200));
  }

  // 6. Smooth anchor scroll for in-page nav links with sticky offset
  document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', e => {
      const id = a.getAttribute('href');
      if (!id || id.length < 2) return;
      const target = document.querySelector(id);
      if (!target) return;
      e.preventDefault();
      const top = target.getBoundingClientRect().top + window.scrollY - 60;
      window.scrollTo({ top, behavior: 'smooth' });
    });
  });
})();
